<script setup lang="ts">
import { Toast } from '~/composables/useToast'
import iconNotice from '~/assets/images/board/ic_tooltip_1.svg'
import iconCheck from '~/assets/images/board/ic_tooltip_2.svg'
import iconWarn from '~/assets/images/board/ic_tooltip_3.svg'

const toasts = Toast.toasts

const getIcon = (type: string) => {
  switch (type) {
    case 'notice':
      return iconNotice
    case 'check':
      return iconCheck
    case 'warning':
      return iconWarn
    default:
      return iconNotice
  }
}
</script>

<template>
  <Teleport to="body">
    <Transition name="toast">
      <div
        v-if="toasts.id !== null"
        class="tooltip"
        :key="toasts.id"
        :class="{ show: toasts.visible }"
      >
        <div>
          <img :src="getIcon(toasts.type)" alt="알림">
        </div>
        <p>{{ toasts.message }}</p>
      </div>
    </Transition>
  </Teleport>
</template>
